import * as styles from './styles.css';
import { ArticleHeading2, Image, UIText2 } from '@cian/ui-kit';

export function MortgageOfferEmpty() {
  return (
    <div className={styles['wrapper']}>
      <div className={styles['img']}>
        <Image
          src={'https://static.cdn-cian.ru/frontend/mortgage-assets/mortgage_promo_frontend/emptySearch.svg'}
          alt="background"
          preloader
        />
      </div>
      <ArticleHeading2>Нет предложений</ArticleHeading2>
      <UIText2>Попробуйте отредактировать параметры</UIText2>
    </div>
  );
}
